import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth.service';
import { MessageService } from 'primeng/api';
import { from } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  const messageService = inject(MessageService, { optional: true });

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/')) {
        return from(auth.refreshTokens()).pipe(
          switchMap((success) => {
            if (success) {
              const cloned = req.clone({
                withCredentials: true,
              });
              return next(cloned);
            }
            auth.logout();
            return throwError(() => error);
          }),
          catchError(() => {
            auth.logout();
            return throwError(() => error);
          })
        );
      }

      if (error.status === 403) {
        messageService?.add({
          severity: 'error',
          summary: 'Access Denied',
          detail: 'You do not have permission to perform this action',
          life: 5000,
        });
      }

      if (error.status === 422 || error.status === 400) {
        const errorData = error.error?.error;
        const detail = errorData?.details
          ? errorData.details.map((d: any) => d.message).join(', ')
          : errorData?.message || 'Validation failed';
        messageService?.add({
          severity: 'warn',
          summary: 'Validation Error',
          detail,
          life: 5000,
        });
      }

      if (error.status >= 500) {
        messageService?.add({
          severity: 'error',
          summary: 'Server Error',
          detail: 'An unexpected error occurred. Please try again.',
          life: 5000,
        });
      }

      return throwError(() => error);
    })
  );
};
